import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CartDrawer } from "@/components/CartDrawer";
import logoText from "@/assets/logo-text.png";
import { Menu, User } from "lucide-react";
import { useState } from "react";

export const LuxuryHeader = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const goToProducts = () => {
    setMobileMenuOpen(false);
    navigate('/products');
  };

  return (
    <>
      <div className="bg-seasonal text-seasonal-foreground text-center py-3 px-4 text-sm md:text-base font-inter font-medium">
        Limited Seasonal Stock • Free Shipping • Ships Same or Next Day
      </div>
      
      <header className="border-b border-border bg-background/95 backdrop-blur sticky top-0 z-50">
        <nav className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex-shrink-0">
            <img 
              src={logoText} 
              alt="Christmas Tree Food" 
              className="h-10 md:h-12" 
              width={110}
              height={48}
            />
          </Link>
          
          <div className="hidden lg:flex items-center gap-8">
            <button 
              onClick={goToProducts}
              className="text-foreground hover:text-primary transition-colors font-inter font-medium"
            >
              Shop
            </button>
            <Link to="/science" className="text-foreground hover:text-primary transition-colors font-inter font-medium">
              The Science
            </Link>
            <Link to="/how-it-works" className="text-foreground hover:text-primary transition-colors font-inter font-medium">
              How It Works
            </Link>
            <Link to="/wholesale" className="text-foreground hover:text-primary transition-colors font-inter font-medium">
              Wholesale
            </Link>
            <Link to="/faq" className="text-foreground hover:text-primary transition-colors font-inter font-medium">
              FAQ
            </Link>
            <Link to="/about" className="text-foreground hover:text-primary transition-colors font-inter font-medium">
              About
            </Link>
            <Link to="/contact" className="text-foreground hover:text-primary transition-colors font-inter font-medium">
              Contact
            </Link>
            <a 
              href="https://lovable-project-2duat.myshopify.com/account" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-foreground hover:text-primary transition-colors font-inter font-medium flex items-center gap-2"
            >
              <User className="h-4 w-4" />
              Account
            </a>
          </div>
          
          <div className="flex items-center gap-4">
            <CartDrawer />
            <Button 
              variant="ghost" 
              size="icon"
              className="lg:hidden"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
              aria-expanded={mobileMenuOpen}
            >
              <Menu className="h-6 w-6" />
            </Button>
          </div>
        </nav>
        
        {mobileMenuOpen && (
          <div className="lg:hidden border-t border-border bg-background">
            <div className="container mx-auto px-4 py-4 space-y-4">
              <button 
                onClick={goToProducts}
                className="block w-full text-left text-foreground hover:text-primary transition-colors font-inter font-medium py-2"
              >
                Shop
              </button>
              <Link 
                to="/science" 
                className="block w-full text-left text-foreground hover:text-primary transition-colors font-inter font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                The Science
              </Link>
              <Link 
                to="/how-it-works" 
                className="block w-full text-left text-foreground hover:text-primary transition-colors font-inter font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                How It Works
              </Link>
              <Link 
                to="/wholesale" 
                className="block w-full text-left text-foreground hover:text-primary transition-colors font-inter font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Wholesale
              </Link>
              <Link 
                to="/faq" 
                className="block w-full text-left text-foreground hover:text-primary transition-colors font-inter font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                FAQ
              </Link>
              <Link 
                to="/about" 
                className="block w-full text-left text-foreground hover:text-primary transition-colors font-inter font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </Link>
              <Link 
                to="/contact" 
                className="block w-full text-left text-foreground hover:text-primary transition-colors font-inter font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </Link>
              <a 
                href="https://lovable-project-2duat.myshopify.com/account" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block w-full text-left text-foreground hover:text-primary transition-colors font-inter font-medium py-2 flex items-center gap-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <User className="h-4 w-4" />
                Account
              </a>
            </div>
          </div>
        )}
      </header>
    </>
  );
};
